import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extracts the first name from a display name.
 * For Google sign-in users, this gets the first word of their full name.
 * For email sign-up users, this returns their specified display name as-is if it's a single word.
 */
export function getFirstName(displayName: string | null | undefined): string {
  if (!displayName) return '';
  
  // Trim and split by spaces
  const parts = displayName.trim().split(/\s+/);
  
  // Return the first part (first name)
  return parts[0] || displayName;
}
